import React from "react";
import { Image, ModalProps } from "react-bootstrap";

import "./DontForgetStepTwoModal.scss";
import BottomModal from "../../BottomModal/BottomModal";
import ImageCloseIcon from "../../../images/close-icon-purple.svg";
import GhostButton from "../../dashboard-page/GhostButton/GhostButton";
import { LINKS } from "../../../utils/constants";
import PrimaryActionButton from "../../Buttons/PrimaryActionButton/PrimaryActionButton";
import { ThemeVariant } from "../../../utils/constants/generic-types";

function DontForgetStepTwoModal({
  show,
  onHide,
  onClickCta,
  theme = ThemeVariant.DARK,
}: ModalProps & { theme?: ThemeVariant; onClickCta?: () => void }) {
  const isLightTheme = theme === ThemeVariant.LIGHT;

  return (
    <BottomModal show={show}>
      <div
        className="dont-forget-step-two-container px-3"
        style={{ background: isLightTheme ? "white" : undefined }}
      >
        <p className="d-flex justify-content-end pt-3 mb-3">
          <GhostButton aria-label="close" onClick={onHide}>
            <Image src={ImageCloseIcon} width={30} height={30} />
          </GhostButton>{" "}
        </p>
        <h5 className="" style={{ color: isLightTheme ? "#262626" : "white" }}>
          Don't Forget To Come Back For Step 2.
        </h5>
        <p
          className="after-text text-center"
          style={{ color: isLightTheme ? "#262626" : "white" }}
        >
          After installing Testflight, come back here immediately to get the
          Hyper app.
        </p>
        <PrimaryActionButton
          text=" I will come back for Step 2."
          href={LINKS.WEBPAGE.TEST_FLIGHT_INSTALL}
          target="_blank"
          rel="noreferrer"
          onClick={onClickCta}
          buttonClassName="fw-bold"
        />
        <GhostButton
          className="cancel-btn"
          onClick={onHide}
          style={{ color: isLightTheme ? "#262626" : "white" }}
        >
          Cancel
        </GhostButton>
      </div>
    </BottomModal>
  );
}

export default DontForgetStepTwoModal;
